interface RoundChargeableWeight {
  productType: string;
  rule: number;
  chargeableWeight: number;
  ruleKey?: string;
}

const convertByRules = (fractionRule = 0.31, weightNumber = 0) => {
  const fraction = weightNumber % 1;

  if (Number(fraction.toFixed(2)) >= fractionRule) {
    return Math.ceil(weightNumber);
  }

  return Math.floor(weightNumber);
};

const convertRound0point5 = ({ chargeableWeight }: RoundChargeableWeight) =>
  Math.ceil(chargeableWeight * 2) / 2;

function roundMalaysiaZeroPointFive(x: number): number {
  const t = Math.trunc(x * 100) / 100;
  if (t <= 0.5) return 0.5;
  const base = Math.floor(t);
  const diff = t - base;
  if (diff === 0) return base;
  if (diff <= 0.5) return base + 0.5;
  return base + 1;
}

export const getRoundedChargeableWeightByRules = (
  params: RoundChargeableWeight
): number => {
  const { productType, rule, chargeableWeight, ruleKey } = params;

  if (ruleKey === "rules-0.5-my") {
    return Math.max(0.5, roundMalaysiaZeroPointFive(chargeableWeight));
  }

  const is0point5 =
    productType.match(/INTERPACK|INTERPACKMAXI/gi) && rule === 0.5;

  if (is0point5) {
    return Math.max(1, convertRound0point5(params));
  }

  return Math.max(1, convertByRules(rule, chargeableWeight));
};
